import React from 'react';
import {
  HomeOutlined,
  UserOutlined,
  ContactsOutlined,
  FileAddOutlined,
  EuroOutlined,
  TagsOutlined,
  FileExcelOutlined,
  BankOutlined,
  ExclamationCircleOutlined,
  CalculatorOutlined,
  FireOutlined,
  MessageOutlined,
  ShopOutlined,
  TeamOutlined,
  DashboardOutlined,
  SettingOutlined,
  CarryOutOutlined,
  SolutionOutlined
} from '@ant-design/icons';
import {
  PortfolioIcon,
  DocumentsIcon,
  ContactsIcon,
  CommissionIcon,
  ContractIcon,
  AmendmentIcon
} from './customIcon';

const navMenuLogos = {
  HOME: <HomeOutlined />,
  USERS: <UserOutlined />,
  CUSTOMERS: <ContactsOutlined />,
  INSURERS: <ContactsOutlined />,
  COMMISSIONS: <EuroOutlined />,
  QUOTES: <FileAddOutlined />,
  CONTRACTS: <ContractIcon />,
  CONTRACTS_CUSTOMER: <ContractIcon />,
  MISSING_PARTS: <FileExcelOutlined />,
  UNPAID_SUSPENDED: <ExclamationCircleOutlined />,
  ACCOUNTING: <CalculatorOutlined />,
  CLAIMS: <FireOutlined />,
  MESSAGES: <MessageOutlined />,
  DOCUMENTS: <DocumentsIcon />,
  CONTACTS: <ContactsIcon />,
  TRACFIN: <BankOutlined />,
  TICKETS: <TagsOutlined />,
  BROKER_PROFILE: <UserOutlined />,
  BROKER_FIRM: <ShopOutlined />,
  BROKER_TEAM: <TeamOutlined />,
  BROKER_DASHBOARD: <DashboardOutlined />,
  BROKER_CLIENTS: <ContactsOutlined />,
  BROKER_SETTINGS: <SettingOutlined />,
  BROKER_COMMISSIONS: <CommissionIcon />,
  BROKER_COMPLIANCE: <CarryOutOutlined />,
  BROKER_CLAIMS: <SolutionOutlined />,
  BROKER_GROUP: <TeamOutlined />,
  QUOTES_MAKE: <FileAddOutlined />,
  QUOTES_SAVED: <PortfolioIcon />,
  QUOTES_IN_EXEMPTION: <ExclamationCircleOutlined />,
  PORTFOLIO_CLIENTS: <UserOutlined />,
  PORTFOLIO_CONTRACTS: <ContractIcon />,
  PORTFOLIO_AMENDMENTS: <AmendmentIcon />,
  PORTFOLIO_AMENDMENTS_IN_EXEMPTION: <ExclamationCircleOutlined />,
  COMPLAINTS: <ExclamationCircleOutlined />,
  ACCOUNTANT: <EuroOutlined />
};

export default navMenuLogos;
